///jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\NewsListScreen.jsx
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Table, Button, Row, Col, Container } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash, FaEye, FaEyeSlash, FaSort } from 'react-icons/fa';
import DOMPurify from 'dompurify';
import { useGetNewsQuery, useDeleteNewsMutation, useToggleNewsVisibilityMutation } from '../../slices/newsApiSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { toast } from 'react-toastify';
import { useState } from 'react';
import Paginate from '../../components/Paginate';

const NewsListScreen = () => {
  const { pageNumber } = useParams();


  const [deleteNews, { isLoading: loadingDelete }] = useDeleteNewsMutation();
  const [toggleVisibility, { isLoading: loadingVisibility }] = useToggleNewsVisibilityMutation();

  const [sortConfig, setSortConfig] = useState({
    key: '_id',
    direction: 'desc',
  });

  const navigate = useNavigate();

  const goToCreateNewsPage = () => {
    navigate('/admin/newsadd');
  };

  const deleteHandler = async (id) => {
    if (window.confirm('Confirmer la suppression ?')) {
      try {
        await deleteNews(id);
        toast.success('Actualité supprimée');
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };
  
    const toggleVisibilityHandler = async (id) => {
      try {
        await toggleVisibility(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    };

    const handleSort = (key) => {
      setSortConfig((prev) => ({
        key,
        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
      }));
      refetch();
    };
  
    const { data, isLoading, error, refetch } = useGetNewsQuery({
      pageNumber,
      isAdminSpace: true,
      sortKey: sortConfig.key,
      sortDirection: sortConfig.direction,
      parPage:20,
    });

  return (
    <Container>
      <Row className="align-items-center">
            <Col>
            <h1 style={{ cursor: 'pointer' }} onClick={() => handleSort('_id')}>
                Actualités <FaSort />
            </h1>
            </Col>
            <Col className="text-end">
            <Button className="my-3" onClick={goToCreateNewsPage}>
                <FaPlus /> Ajouter une actu
            </Button>
            </Col>
        </Row>
      {loadingDelete && <Loader />}
      {loadingVisibility && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error.data.message}</Message>
      ) : (
        <>
            <Table striped bordered hover responsive className="table-sm">
                <thead>
                <tr>
                    <th onClick={() => handleSort('title')} style={{ cursor: 'pointer' }}>
                    Titre <FaSort />
                    </th>
                    <th onClick={() => handleSort('event')} style={{ cursor: 'pointer' }}>
                    Dates et lieu <FaSort />
                    </th>
                    <th onClick={() => handleSort('description')} style={{ cursor: 'pointer' }}>
                    Texte <FaSort />
                    </th>
                    <th onClick={() => handleSort('isVisible')} style={{ cursor: 'pointer' }}>
                    Actions <FaEye style={{ color: 'grey' }} />
                    </th>
                </tr>
                </thead>
                <tbody>
                {data?.news?.map((news) => (
                    <tr key={news._id}>
                    <td>
                        <Link
                        to={`/admin/news/${news._id}/edit`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        title="Modifier la fiche"
                        >
                        {news.title}
                        </Link>
                    </td>
                    <td>
                        <Link
                        to={`/admin/news/${news._id}/edit`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        title="Modifier la fiche"
                        >
                        {news.event ? news.event.slice(0, 50) + '...' : 'Non défini'}
                        </Link>
                    </td>
                    <td>
                        <Link
                        to={`/admin/news/${news._id}/edit`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        title="Modifier la fiche"
                        >
                          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.description.slice(0, 50) + '...') }} />
                        </Link>
                    </td>
                    <td>
                        <Button
                        as={Link}
                        to={`/admin/news/${news._id}/edit`}
                        variant="light"
                        className="btn-sm mx-2"
                        title="Modifier la fiche"
                        >
                        <FaEdit />
                        </Button>
                        <Button
                        variant="light"
                        className="btn-sm"
                        onClick={() => toggleVisibilityHandler(news._id)}
                        title={news.isVisible ? 'Cacher la fiche' : 'Rendre la fiche visible'}
                        >
                        {news.isVisible ? (
                            <>
                            <FaEye style={{ color: 'turquoise' }} />
                            <FaEyeSlash style={{ color: 'grey' }} />
                            </>
                        ) : (
                            <>
                            <FaEye style={{ color: 'grey' }} />
                            <FaEyeSlash style={{ color: 'red' }} />
                            </>
                        )}
                        </Button>
                        <Button
                        variant="light"
                        className="btn-sm"
                        onClick={() => deleteHandler(news._id)}
                        title={
                            news.isVisible
                            ? 'Seules les fiches non visibles peuvent être supprimées'
                            : 'Supprimer la fiche'
                        }
                        disabled={news.isVisible}
                        >
                        <FaTrash style={news.isVisible ? { color: 'grey' } : { color: 'red' }} />
                        </Button>
                    </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <Paginate pages={data.pages} page={data.page} isAdmin={true} basePath="/admin/newslist" />
        </>
      )}
    </Container>
  );
};

export default NewsListScreen;
